import { useEffect, useState } from 'react';
import { LinkedinShareButton, TwitterShareButton } from 'react-share';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { CheckIcon } from '@heroicons/react/24/solid';
import { LinkedInIcon, TwitterIcon, MailIcon, LinkIcon } from '@/components/icons';
type ShareOptionsProps = {
  shortId: string;
  title: string;
  source: string;
};

export const ShareOptions: React.ElementType<ShareOptionsProps> = ({ shortId, title, source }) => {
  const [shareUrl, setShareUrl] = useState<string>();
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setShareUrl(`${window.location.protocol}//${window.location.host}/discovercalls/${shortId}`);
    }
  }, [shortId]);

  const [linkCopied, setLinkCopied] = useState(false);
  const handleLinkCopied = () => {
    setLinkCopied(true);
    setTimeout(() => setLinkCopied(false), 2000);
  };

  return (
    <>
      {shareUrl && (
        <div className="flex items-center gap-2  sm:flex-wrap text-content-secondary">
          <span className="text-base font-normal leading-6 m-0 ">Share</span>
          <LinkedinShareButton translate="yes" url={shareUrl} title={title} source={source}>
            <div className="w-10 h-10 flex items-center justify-center border  rounded-lg bg-general-neutral-white transition-colors duration-200 border-outline-neutral-light">
              <LinkedInIcon className="w-5 h-5" />
            </div>
          </LinkedinShareButton>

          <TwitterShareButton
            translate="yes"
            url={shareUrl}
            title={title}
            className="w-10 h-10 flex items-center justify-center border  rounded-lg bg-general-neutral-white transition-colors duration-200 border-outline-neutral-light"
          >
            <div className="w-10 h-10 flex items-center justify-center border rounded-lg bg-general-neutral-white transition-colors duration-200 border-outline-neutral-light">
              <TwitterIcon className="w-5 h-5" />
            </div>
          </TwitterShareButton>

          <a
            target="_blank"
            rel="noreferrer noopener"
            href={`mailto:?subject=${title}&body=${shareUrl}`}
            className="w-10 h-10 flex items-center justify-center border  rounded-lg bg-general-neutral-white transition-colors duration-200 border-outline-neutral-light"
          >
            <MailIcon className="w-5 h-5" />
          </a>

          {/* @ts-ignore */}
          <CopyToClipboard text={shareUrl} onCopy={handleLinkCopied}>
            <button className="w-10 h-10 flex items-center justify-center border rounded-lg bg-general-neutral-white transition-colors duration-200 border-outline-neutral-light">
              {linkCopied ? <CheckIcon className="w-5 h-5" /> : <LinkIcon className="w-5 h-5" />}
            </button>
          </CopyToClipboard>
        </div>
      )}
    </>
  );
};
